import DentistSignUpForm from "../../components/FindDentist/DentistSignUpForm";

const DentistEnrollment = () => {
  return (
    <div className="bg-light">
      <DentistSignUpForm></DentistSignUpForm>
    </div>
  );
};

export default DentistEnrollment;
